import { memo, useState } from 'react'
import { createPortal } from 'react-dom'
import { usePopper } from 'react-popper'

import { GTransition } from '../g-transition'
import { GTooltipProps } from './types'

export const GTooltip = ({
	position = 'bottom',
	children,
	containerClassName,
	childrenContainerClassName,
	className,
	content,
	contentClassName,
	contentTitle,
	arrowClassName,
	persist = false,
	...props
}: GTooltipProps) => {
	const [show, setShow] = useState(false)

	const [referenceElement, setReferenceElement] = useState<HTMLElement | null>(
		null
	)
	const [popperElement, setPopperElement] = useState<HTMLElement | null>(null)
	const [arrowElement, setArrowElement] = useState<HTMLElement | null>(null)
	const { styles, attributes } = usePopper(referenceElement, popperElement, {
		placement: position,
		modifiers: [{ name: 'arrow', options: { element: arrowElement } }, { name: 'flip', enabled: false }]
	})

	if (!content) return <>{children}</>

	const popper = (
		<div
			ref={setPopperElement}
			data-theme="light"
			className={`${className} absolute z-50 ${persist ? '' : 'pointer-events-none'}`}
			style={styles.popper}
			{...attributes.popper}
			onMouseLeave={() => persist && setShow(false)}
			onPointerLeave={() => persist && setShow(false)}
		>
			<GTransition show={show}>
				<div
					className={`
						' ${
							contentClassName ? contentClassName : 'bg-white text-t-default'
						}  shadow-lg px-4 py-2 rounded-lg border text-sm max-w-lg whitespace-normal'
					`}
					onClick={() => !persist && setShow(false)}
				>
					{contentTitle}
					<br className={contentTitle ? 'block' : 'hidden'}/>
					{content}
				</div>
				<div ref={setArrowElement} style={styles.arrow} className={arrowClassName}
				 />
			</GTransition>
		</div>
	)

	return (
		<div className={`${containerClassName} group inline-block`} {...props}>
			<div
				ref={setReferenceElement}
				className={`${childrenContainerClassName} cursor-pointer`}
				onMouseEnter={() => setShow(true)}
				onPointerEnter={() => setShow(true)}
				onClick={() => setShow(true)}
				onMouseLeave={() => !persist && setShow(false)}
				onPointerLeave={() => !persist && setShow(false)}
			>
				{children}
			</div>

			{typeof document !== 'undefined' ? createPortal(popper, document.body) : popper}
		</div>
	)
}

const tooltipContentAreEqual = (prevProps: any, nextProps: any) => {
	return prevProps.content === nextProps.content
}
memo(GTooltip, tooltipContentAreEqual)
